import React from 'react';

/**
 * Interface for manipulation of context and event triggering.
 * Implementation is defined in TrackingProvider. `_data` is intended for internal
 * use only and should be considered private.
 */
const context = {
    _data: { // Intended for private use only
        eventFields: {},
        eventOptions: {},
        fields: {},
        options: {},
        // The original function passed in to TrackingProvider
        trigger: null
    },
    // Used to determine if a Provider exists in the context chain.
    hasProvider: false,
    // The trigger function passed in to TrackingProvider wrapped with data merging.
    trigger: () => {}
};

// React.createContext will return an object with Provider and Consumer members.
const TrackingContext = React.createContext(context);

export default TrackingContext;
